import React from 'react'
import Partners from '../components/Partners/Partners'

const Partner = () => {
  return (
    <div>
        <Partners />
    </div>
  )
}

export default Partner